import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Redo = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M16.886 18.916H9.014c-2.716 0-4.92-2.307-4.92-5.15s2.204-5.15 4.92-5.15h10.824'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='m17.575 11.19 2.519-2.637-2.52-2.637'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.014 9.365c-2.27 0-4.17 1.94-4.17 4.4 0 2.462 1.9 4.401 4.17 4.401h7.872a.75.75 0 0 1 0 1.5H9.014c-3.162 0-5.67-2.676-5.67-5.9s2.508-5.9 5.67-5.9h10.824a.75.75 0 0 1 0 1.5z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.057 5.374a.75.75 0 0 1 1.06.024l2.52 2.637a.75.75 0 0 1 0 1.036l-2.52 2.637a.75.75 0 1 1-1.085-1.036l2.024-2.119-2.024-2.119a.75.75 0 0 1 .025-1.06'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
